import { render, staticRenderFns } from "./SchoolCollaboration.vue?vue&type=template&id=5e0b340b&scoped=true&"
import script from "./SchoolCollaboration.vue?vue&type=script&lang=js&"
export * from "./SchoolCollaboration.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCollaboration.vue?vue&type=style&index=0&id=5e0b340b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b340b",
  null
  
)

export default component.exports